import React from "react";
import { useFormContext } from "react-hook-form";
import { Text } from "$components";
import CField from "$forms/CField";
import FileUploader from "$components/FileUploader/FileUploader";
import { useDockyardFormContext } from "../context/DockyardFormContext";
import useAuth from "$hooks/useAuth";

export const AttachmentsSection: React.FC = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { currentCompany, dockyard } = useDockyardFormContext();
  const { isAdmin } = useAuth();

  return (
    <>
      <div className="bordered">
        <Text type="h3">Pièces jointes</Text>
      </div>
      <CField control={control} name="medias" error={errors.medias}>
        {(props) => (
          <FileUploader
            company={currentCompany}
            type="dockyard"
            id={dockyard?._id}
            isEdit={false}
            isLargeVersion
            {...props}
            isAdmin={isAdmin()}
          />
        )}
      </CField>
    </>
  );
};
